var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"10"}},[_c('v-card-text',[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"pl-2"},[_vm._v(_vm._s(_vm.subtitle))]),_c('GChart',{attrs:{"type":"PieChart","data":_vm.chartData,"options":_vm.chartOptions}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }